module.exports = __webpack_public_path__ + "static/media/logo_e2e.d1fe278a.png";